import { defineMessages } from "react-intl";

import { messages } from "lib/build/forms/messages/fsn";

const commonFsnMessages = defineMessages({
	"fyrms|general_practitioner_of_the_patient": {
		id: "fyrms|general_practitioner_of_the_patient",
		defaultMessage: "A beteg háziorvosa"
	},
	"loinc|55174-7": {
		id: "loinc|55174-7",
		defaultMessage: "Beteg azonosítási adatok DEEDS"
	},
	"loinc|56799-0": {
		id: "loinc|56799-0",
		defaultMessage: "Cím"
	},
	"snomed|169812000": {
		id: "snomed|169812000",
		defaultMessage: "Születési hely"
	},
	"snomed|184095009": {
		id: "snomed|184095009",
		defaultMessage: "Beteg keresztneve"
	},
	"snomed|184096005": {
		id: "snomed|184096005",
		defaultMessage: "Beteg vezetékneve"
	},
	"snomed|184097001": {
		id: "snomed|184097001",
		defaultMessage: "Beteg címe"
	},
	"snomed|184098006": {
		id: "snomed|184098006",
		defaultMessage: "Beteg titulusa"
	},
	"snomed|184099003": {
		id: "snomed|184099003",
		defaultMessage: "Születési dátum"
	},
	"snomed|184107009": {
		id: "snomed|184107009",
		defaultMessage: "Beteg kórházi száma"
	},
	"snomed|302147001": {
		id: "snomed|302147001",
		defaultMessage: "Demográfiai történet részletek"
	},
	"snomed|315354004": {
		id: "snomed|315354004",
		defaultMessage: "Születési ország"
	},
	"snomed|398093005": {
		id: "snomed|398093005",
		defaultMessage: "Társadalombiztosítási szám"
	},
	"snomed|423203003": {
		id: "snomed|423203003",
		defaultMessage: "Leánykori név"
	},
	"snomed|423775007": {
		id: "snomed|423775007",
		defaultMessage: "Anya leánykori neve"
	},
	"snomed|734000001": {
		id: "snomed|734000001",
		defaultMessage: "Biológiai nem"
	},
	"snomed|734005006": {
		id: "snomed|734005006",
		defaultMessage: "Telefonszám"
	}
});

export const fsnMessages = { ...commonFsnMessages, ...messages };
